module.exports = __webpack_public_path__ + "img/Cumulative - Impact assessment.d4ebbed1.svg";